const letsTry = (text) => {
  console.log(`Let's try some ECMAScript 6! ${text}`)
}

letsTry('It\'s really cool!')



/** WEBPACK FOOTER **
 ** ./assets/scripts/main.js
 **/